module.exports = __webpack_public_path__ + "static/media/allium_logo.d3b03ec1.png";